export enum EAction {
    SetRouters = '@internet/routers/set',
    SetLoading = '@internet/loading/set',

    SetArticles = '@internet/articles/set',
    ToggleAnswer = '@internet/articles/answer/toggle',

    SetSectionVisibility = '@internet/sections/visibility/set',
}
